module.exports = __webpack_public_path__ + "static/support-d531b98f54a7ad0f1ebe16a81567dcd3.jpg";